import React from 'react';
import { Calendar, Car, CheckCircle, ArrowRight, Shield, Truck, Headphones } from 'lucide-react';
import { Button } from './ui/button';

const HowItWorks = ({ language }) => {
  const scrollToBooking = () => {
    const el = document.getElementById('booking');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const steps = [
    {
      icon: Calendar,
      titleRo: 'Alege datele',
      titleEn: 'Choose your dates',
      descRo: 'Selectează locația de ridicare și perioada de închiriere',
      descEn: 'Select your pickup location and rental period',
    },
    {
      icon: Car,
      titleRo: 'Alege mașina',
      titleEn: 'Pick your car',
      descRo: 'Vezi instant mașinile disponibile și prețurile transparente',
      descEn: 'Instantly see available cars and transparent pricing',
    },
    {
      icon: CheckCircle,
      titleRo: 'Rezervă instant',
      titleEn: 'Book instantly',
      descRo: 'Confirmă în câteva click-uri, fără taxe ascunse',
      descEn: 'Confirm in a few clicks with no hidden fees',
    },
  ];

  const trustSignals = [
    { icon: Shield, textRo: 'Fără taxe ascunse', textEn: 'No hidden fees' },
    { icon: Truck, textRo: 'Livrare gratuită în Brașov', textEn: 'Free delivery in Brașov' },
    { icon: Headphones, textRo: 'Suport rapid clienți', textEn: 'Fast customer support' },
  ];

  const isEn = language === 'en';

  return (
    <section className="py-16 sm:py-20 bg-white" data-testid="how-it-works-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#10B981] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
            {isEn ? 'How it works' : 'Cum funcționează'}
          </p>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-[#0D1B3E]">
            {isEn ? 'Rent a car in less than 2 minutes' : 'Închiriază o mașină în mai puțin de 2 minute'}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 max-w-4xl mx-auto mb-12">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <div key={i} className="text-center" data-testid={`how-step-${i + 1}`}>
                <div className="relative inline-flex items-center justify-center mb-5">
                  <div className="w-16 h-16 rounded-full bg-[#ECFDF5] flex items-center justify-center">
                    <Icon className="text-[#10B981]" size={28} strokeWidth={1.8} />
                  </div>
                  <span className="absolute -top-1 -right-1 w-6 h-6 bg-[#0D1B3E] text-white text-xs font-bold rounded-full flex items-center justify-center">
                    {i + 1}
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold text-[#0D1B3E] mb-2">
                  {isEn ? step.titleEn : step.titleRo}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {isEn ? step.descEn : step.descRo}
                </p>
              </div>
            );
          })}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10 mb-10">
          {trustSignals.map((signal, i) => {
            const Icon = signal.icon;
            return (
              <div key={i} className="flex items-center gap-2 text-gray-600" data-testid={`trust-signal-${i + 1}`}>
                <Icon size={18} className="text-[#10B981]" strokeWidth={2} />
                <span className="text-sm font-medium">{isEn ? signal.textEn : signal.textRo}</span>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            onClick={scrollToBooking}
            data-testid="how-it-works-cta"
            className="bg-[#10B981] hover:bg-[#0EA472] text-white font-semibold px-8 h-12 text-base rounded shadow-md hover:shadow-lg transition-all"
          >
            {isEn ? 'Check availability' : 'Verifică disponibilitatea'}
            <ArrowRight className="ml-2" size={18} />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
